import { render, staticRenderFns } from "./MultilobbyMatch.vue?vue&type=template&id=381cec5f&scoped=true"
import script from "./MultilobbyMatch.vue?vue&type=script&lang=js"
export * from "./MultilobbyMatch.vue?vue&type=script&lang=js"
import style0 from "./MultilobbyMatch.vue?vue&type=style&index=0&id=381cec5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381cec5f",
  null
  
)

export default component.exports